<template>
    <DFormRow
        class="ssn-check"
        :label="__('customers.customers.ssn')"
    >
        <div class="ssn-container">
            <DInput
                id="business_id"
                v-model="SSN"
                :placeholder="__('customers.customers.ssn')"
                maxlength="12"
                @update:modelValue="updateValue"
            />
            <DButton
                id="ssn-check"
                class="ssn-check"
                :label="__('customers.customers.ssn_business_id_check_button')"
                color="primary"
                @click="checkSSNField"
            />
        </div>
        <p
            v-if="SSNCheckMessage"
            :class="SSNErrorValid ? 'ssn-check-msg-color-valid' : 'ssn-check-msg-color-invalid'"
            class="ssn-check-msg"
        >
            {{ SSNCheckMessage }}
        </p>
    </DFormRow>
</template>

<script setup>
import { __ } from '~@/Composables/translation'
import { ref } from 'vue'

const emit = defineEmits(['ssn-check', 'update:modelValue'])

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    ssn: {
        type: String,
        default: () => { return '' }
    },
    ssnCheckOnEdit: {
        type: Boolean,
        default: () => { return false }
    }
})

const SSN = ref(props.ssn)
const SSNValid = ref(false)
const birthday = ref(null)
const bornIn20thCenturyCodes = ['-', 'Y', 'X', 'W', 'V', 'U']
// const bornInOrAfter2000Codes = ['A', 'B', 'C', 'D', 'E', 'F']
const currentYear = new Date().getFullYear()
const SSNCheckMessage = ref('')
const SSNErrorMessage = __('customers.customers.ssn_check_error')
const SSNErrorValid = ref(true)

if (SSN.value !== null && props.ssnCheckOnEdit) {
    checkSSNField()
}

const updateValue = function updateValue (value) {
    emit('update:modelValue', value)
}

function checkSSNField () {
    SSNValid.value = false
    birthday.value = null
    SSNErrorValid.value = false
    if (SSN.value === null) {
        SSNCheckMessage.value = __('customers.customers.no_ssn_code')
        SSNErrorValid.value = false
        return
    }
    const SSNLength = SSN.value.length
    if (SSNLength === 11) {
        const SSNBirthdayPart = SSN.value.substring(0, SSNLength - 4)
        SSNValid.value = /^\d{6}[ABCDEF\-YXWVU]$/.test(SSNBirthdayPart)
        if (SSNValid.value) {
            const yearCode = SSNBirthdayPart.substring(6, 7)
            const SSNDay = SSNBirthdayPart.substring(0, 2)
            const SSNMonth = SSNBirthdayPart.substring(2, 4)
            const SSNYear = SSNBirthdayPart.substring(4, 6)
            const century = bornIn20thCenturyCodes.includes(yearCode) ? 1900 : 2000
            const birthdayYear = century + parseInt(SSNYear)
            const customerAge = currentYear - birthdayYear
            const customerOver17 = customerAge > 17
            const isAgeOk = customerOver17 ? __('customers.customers.ssn_age_ok') : __('customers.customers.ssn_age_not_ok')
            SSNErrorValid.value = customerOver17
            birthday.value = birthdayYear + '-' + SSNMonth + '-' + SSNDay
            SSNCheckMessage.value = __('customers.customers.ssn_birthday') + ' ' + birthday.value + ', ' + isAgeOk
        } else {
            SSNCheckMessage.value = SSNErrorMessage
        }
    } else {
        SSNCheckMessage.value = SSNErrorMessage
    }
    emit('ssn-check', SSNValid.value, birthday.value, SSN.value)
}

</script>

<style scoped lang="scss">
.ssn-check.content.error {
    color: #0D904F !important;
}
.ssn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    .ssn-check {
        margin-left: 10px;
    }
}
.ssn-check-msg {
    margin: 3px 0 0 0;
    font-size: 12px;
}
.ssn-check-msg-color-valid {
    color: var(--colorSuccess);
}
.ssn-check-msg-color-invalid {
    color: var(--colorDanger);
}
</style>
